import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppContext from "../../../AppContext";
import WorkExchangeContext from "../../../contexts/WorkExchangeContext";

import { ReactComponent as PlaySvg } from "../../../assets/icons/play.svg";
import MaterialImage from "../../../assets/home/workExchange/materials.jpeg";
import Image3D from "../../../assets/home/workExchange/3d.jpeg";
import DrawingImage from "../../../assets/home/workExchange/drawing.jpeg";
import StylishButton from "../../common/StylishButton";

import "../../../styles/landingPage/work-exchange.scss";
import { useNavigate } from "react-router-dom";

const Item = ({ name, value, onSeeMore, onClick }) => {
  const { setWorkExchangeFilter } = useContext(WorkExchangeContext);
  const handleClickItem = () => {
    setWorkExchangeFilter({ currentSelect: value });
    onClick();
  };

  const getImage = () => {
    if (name === "3D Models") return Image3D;
    if (name === "Materials and lighting") return MaterialImage;
    if (name === "Drawing and block CAD") return DrawingImage;
  };

  return (
    <div className="lp-work-exchange-content-item" onClick={handleClickItem}>
      <img
        className="lp-work-exchange-content-item__image"
        alt="work"
        src={getImage()}
      />
      <div className="lp-work-exchange-content-item-title">
        <div className="lp-work-exchange-content-item-title__desc">{name}</div>
      </div>
    </div>
  );
};

const WorkExchange = ({ onSeeMore }) => {
  const { getLang, designStyles } = useContext(AppContext);
  const { setWorkExchangeFilter } = useContext(WorkExchangeContext);
  const [workExchanges, setWorkExchanges] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!designStyles?.workExchanges) return;
    setWorkExchanges(designStyles.workExchanges);
  }, [designStyles]);

  const handleClickSeeMore = () => {
    setWorkExchangeFilter({ currentSelect: undefined });
    onSeeMore();
  };

  const handleTypeClick = (id) => {
    navigate(`/art-designs/work-exchanges/${id}`);
  };

  return (
    <div className="lp-work-exchange">
      <div className="lp-work-exchange-header">
        <div className="lp-work-exchange-header__title">
          <h2>Work</h2>
          <h2>Exchange</h2>
        </div>
        <div className="lp-work-exchange-header__sub">
          Explore projects made by various creators
        </div>
        <StylishButton
          label="See more"
          icon={<PlaySvg />}
          onClick={handleClickSeeMore}
          size="small"
        />
      </div>
      <div className="lp-work-exchange-content">
        {workExchanges.map((m, index) => {
          return (
            <Item {...m} key={index} onClick={() => handleTypeClick(m.value)} />
          );
        })}
      </div>
    </div>
  );
};

WorkExchange.propTypes = {
  onSeeMore: PropTypes.func,
};

WorkExchange.defaultProps = {
  onSeeMore: () => {},
};

export default WorkExchange;
